import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('FacebookCircleIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="connect__icon icon icon__facebook-circle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130">
        <circle className="circle" cx="65" cy="65" r="63"/>
        <circle className="circle circle__inner" cx="65" cy="65" r="60"/>
        <path className="foreground" d="M74.67,57.47h-6V53.54c0-1.49.94-1.81,1.65-1.81H74.6V45.21H68.78c-6.52,0-7.94,4.87-7.94,7.94v4.32H57.07v6.68h3.77V83.09H68.7V64.15H74Z"/>
      </svg>
    ), el);
  });
};
